import React from 'react'
import { Card, Button } from 'antd-mobile'
import { YenSpan } from '../../../components_renew/common/YenSpan'

class OrderConfirmItem extends React.PureComponent {

  // state = { extra: '点击选择折扣券' }

  // componentDidUpdate (prevProps, prevState, snapshot) {
  //   let { ticketUsable, selectedTicket } = this.props
  //   if (ticketUsable && (prevProps.selectedTicket !== selectedTicket)) {
  //     let extra = selectedTicket ? selectedTicket['couponDesc'] : '点击选择折扣券'
  //     this.setState({ extra })
  //   }
  // }

  render () {
    const {
      productName, productCount, currentPrice, productPic, couponData, couponList,
      onCouponClick
    } = this.props
    if (couponList) {
      console.group('confirm item render')
      console.log(this.props)
      console.groupEnd()
    }
    // let { extra } = this.state
    return <Card className={'m-4'}>
      <div className={'flex'}>
        <img className={'h-auto w-24'} src={productPic} alt=""/>
        <div className={'flex-auto ml-4'}>
          <div className={'line-clamp-2 mb-4'}>
            {productName}
          </div>
          <div className={'flex justify-between'}>
            <YenSpan>{currentPrice}</YenSpan>
            <div className={'text-sm'} style={{ color: 'var(--adm-color-weak)' }}>
              x {productCount}
            </div>
          </div>
        </div>
      </div>
      {/*<Card.Body>*/}
      {/*  <Flex align={'start'}>*/}
      {/*    <img className={'item-card__thumb'} src={productPic} alt=''/>*/}
      {/*    <div className={'item-card__content'}>*/}
      {/*      <div className='item-card__title'>*/}
      {/*        {productName}*/}
      {/*      </div>*/}
      {/*      <Flex justify={'between'}>*/}
      {/*        <YenSpan className='item-card__price'>{currentPrice}</YenSpan>*/}
      {/*        <div className='item-card__amount'>*/}
      {/*          x {productCount}*/}
      {/*        </div>*/}
      {/*      </Flex>*/}
      {/*    </div>*/}
      {/*  </Flex>*/}
      {/*</Card.Body>*/}
      {
        couponList && couponList.length > 0
          ? <div className={'flex justify-end items-center'}>
            <Button size={'mini'}
                    fill={'outline'}
                    color={'primary'}
                    onClick={onCouponClick}>
              <i className={'icon-font icon-arrow-down-bold'}/>
              {couponData ? couponData['couponDesc'] : '点击选择折扣券'}
            </Button>
          </div>
          // <Card.Footer onClick={onCouponClick}
          //              extra={<div className='item-card__extra'><i className={'icon-font icon-arrow-down-bold'}/>
          //                &nbsp;
          //                {couponData ? couponData['couponDesc'] : '点击选择折扣券'}
          //              </div>}/>

          : null
      }
      <br/>
      {
        (couponData && couponData['value'])
          // ? <Card.Footer extra={`折扣券抵扣 ${couponData['label']}`}/>
          ? <div className={'flex justify-end items-center text-xs text-gray-500'}>
            折扣券抵扣 {couponData['label']}
          </div>
          : null
      }
    </Card>
  }
}

export { OrderConfirmItem }
